import { createSelector } from 'reselect';

import { EVENT_CONFIG } from 'works/components/Content/components/Common/modalUtils';
import { isSalesOrParts as isSalesOrPartsSelector } from 'modules/entity/subEntities/intervention/selectors';

import { getUI } from '.';

export const getData = createSelector(getUI, ui => ui.interventionUpdateModalData);

const isOpen = createSelector(getUI, ui => ui.isInterventionUpdateModalOpen);

export const getContent = createSelector(getData, isSalesOrPartsSelector, (data, isSalesOrParts) => {
  const { type, ...updatedData } = data ?? {};
  if (type) {
    const changes = Object.entries(updatedData)
      .filter(([_, isEnabled]) => isEnabled)
      .map(([fields, _]) => fields);

    const config = EVENT_CONFIG({ isSalesOrParts })[type];
    const matchingField = changes.find(field => Boolean(config[field]));
    return (matchingField !== undefined ? config?.[matchingField] : undefined) ?? config?.default;
  }
  return undefined;
});

export const isVisible = createSelector(isOpen, getContent, (open, content) => open && content);
